/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddGroupDto as DigiworkMaitreDPosDtoGroupAddGroupDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Group/add-group-dto';
import { GroupDto as DigiworkMaitreDPosDtoGroupGroupDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Group/group-dto';

export interface AddGroup$Params {
      body?: DigiworkMaitreDPosDtoGroupAddGroupDto
}

export function addGroup(http: HttpClient, rootUrl: string, params?: AddGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>> {
  const rb = new RequestBuilder(rootUrl, addGroup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>;
    })
  );
}

addGroup.PATH = '/api/groups';
